import { render, staticRenderFns } from "./InfoBannerDismissible.vue?vue&type=template&id=2085bf36&scoped=true&lang=pug"
import script from "./InfoBannerDismissible.vue?vue&type=script&lang=js"
export * from "./InfoBannerDismissible.vue?vue&type=script&lang=js"
import style0 from "./InfoBannerDismissible.vue?vue&type=style&index=0&id=2085bf36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2085bf36",
  null
  
)

export default component.exports